<template>
    <div v-html="$t('views.otp.desc', { referCode: data.useForm.modelRef.code })"></div>
    <div v-html="$t('views.otp.otp', { referCode: data.useForm.modelRef.otp })"></div>
    <Form :ref="(e) => (refs.form = e)" layout="horizontal">
        <TemplateBuilder :rowProp="dataProp.rowProp" :useForm="dataProp.useForm" :fields="data.fields"></TemplateBuilder>
    </Form>
    <a disabled v-if="!data.isGenOtp">
        <CIcon file="refresh.svg"></CIcon>
        <span class="ml-2" :style="data.color"> {{ $t("views.otp.resendCount", { time: data.timeGen }) }}</span>
    </a>
    <a @click="() => resend({ props, data, refs })" v-if="data.isGenOtp">
        <CIcon file="refresh.svg"></CIcon>
        <span class="ml-2">{{ $t("views.otp.resend") }}</span>
    </a>
    <span style="color:red">{{ $t("views.otp.importantRemark") }}</span>
</template>

<script>
import { defineComponent, reactive, defineAsyncComponent } from "vue";
import { initForm, resend, onClickModalOk } from "./verify-otp.logic";
import { Form } from "ant-design-vue";

export default defineComponent({
    components: {
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../icon/CIcon")),
    },
    props: {
        menuContext: {},
        viewOnly: {},
        dataProp: {},
    },
    setup(props, { emit }) {
        const data = reactive({ ...props.dataProp, isGenOtp: false });
        const refs = reactive({});
        initForm({ props, data, refs, emit });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        return { props, data, refs, resend, callOnClickModalOk };
    },
});
</script>
